import { HEADER_BYTE_LENGTH } from './header-byte-length';

export class Envelope {
  constructor(
    public readonly flags: number,
    public readonly bytes: Uint8Array,
  ) {}

  public static encode<T extends Envelope>(envelope: T): Uint8Array {
    const { flags, bytes } = envelope;
    const chunk = new Uint8Array(bytes.byteLength + HEADER_BYTE_LENGTH);
    const view = new DataView(chunk.buffer, chunk.byteOffset, chunk.byteLength);

    view.setUint8(0, flags);
    view.setUint32(1, bytes.byteLength, false);

    chunk.set(bytes, HEADER_BYTE_LENGTH);

    return chunk;
  }
}
